import { Icon, Row, Col } from "antd";
import * as React from "react";
import * as Logo from "src/assets/logos/precatorios-brasil/logo.svg";
import { Layout } from "antd";
import { Link } from "react-router-dom";

import "./header.scss";

export function OfficerHeader(props) {
  const { login } = props.currentUser;
  const { Header } = Layout;
  return (
    <Header>
      <Row type="flex">
        <Col>
          <span className="toggler" onClick={() => props.setSidebarOpen(!props.sidebarOpen)}>
            <Icon type={!props.sidebarOpen ? "menu-unfold" : "menu-fold"} />
          </span>
        </Col>

        {!props.isBlackFriday && (
          <Col
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              paddingRight: "6px",
              paddingLeft: "6px",
              borderRadius: "8px",
              position: "relative",
              background: "transparent"
            }}
          >
            <img src={Logo} style={{ height: "80px" }} />
            {/* <span>Parceiros</span> */}
          </Col>
        )}
        {props.isBlackFriday && (
          <Col
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              paddingRight: "6px",
              paddingLeft: "6px",
              borderRadius: "8px"
            }}
          >
            <div className="black-december-logo">
              <Link to={"/"}>
                <h1>
                  Black <span>December</span>
                </h1>
                <span className="partners">Parceiros</span>
              </Link>
            </div>
          </Col>
        )}
        {!props.isBlackFriday && <Col style={{ marginRight: "20px" }}>{`Login: ${login}`}</Col>}
      </Row>
    </Header>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/main-layout/Header.tsx